import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DevIconsComponent } from './icons/dev-icons.component';
import { UiKitStylesPageComponent } from './ui-kit-styles-page/ui-kit-styles-page/ui-kit-styles-page.component';
import { DevPageComponent } from './dev-page/dev-page.component';
import { InputPageComponent } from './input-page/input-page.component';

const routes: Routes = [
  {
    path: '',
    component: DevPageComponent,
    children: [
      {
        path: 'icons', component: DevIconsComponent,
      },
      {
        path: 'inputs', component: InputPageComponent,
      },
      {
        path: 'ui-kit-styles', component: UiKitStylesPageComponent,
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [],
  declarations: [],
})
export class DevPagesRoutingModule {
}
